import React from 'react';
import { ChangeItem, AttentionItem } from '../../../../types/dashboard-v4.types';
import { PanelHeading } from './PanelHeading';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { Button } from '../../../ui/button';

interface ActivityFeedProps {
  whatsChanged: ChangeItem[];
  whatNeedsAttention: AttentionItem[];
  onAttentionItemClick: (item: AttentionItem) => void;
}

export const ActivityFeed: React.FC<ActivityFeedProps> = ({
  whatsChanged,
  whatNeedsAttention,
  onAttentionItemClick
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">
          What's changed?
        </CardTitle>
        <div className="text-[12px] text-[#262628]" style={{ fontFamily: 'Open Sans, sans-serif' }}>
          Updates to your signals and complaints
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        
        <div className="space-y-5">
          {whatsChanged.map((item) => (
            <div key={item.id} className="relative">
              <p className="text-[13px] font-bold text-[#262628] leading-normal mb-[5px]" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                {item.count} {item.title}
              </p>
              <p className="text-[11px] text-[#262628] leading-normal" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* What Needs Your Attention Section */}
        <div className="mt-6">
          <h3 className="text-base font-semibold mb-4">
            What needs your attention
          </h3>
        <div className="space-y-[10px]">
          {whatNeedsAttention.map((item) => (
            <div
              key={item.id}
              className="bg-[#F4F4F4] p-[15px] rounded-lg cursor-pointer"
              onClick={() => onAttentionItemClick(item)}
            >
              <h3 className="text-[11.5px] font-bold text-[#262628] mb-[5px] leading-normal" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                {item.title}
              </h3>
              <p className="text-[10px] text-[#262628] leading-normal mb-[12px]" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                {item.description}
                {/* Add most relevant classification summary */}
                {(() => {
                  // Determine the most relevant summary based on the item type and severity
                  let primarySummary = null;
                  let additionalSummaries = [];
                  
                  // Priority order: Harm > Vulnerability > Strain > Regulatory
                  if (item.harmSummary) {
                    primarySummary = item.harmSummary;
                  } else if (item.vulnerabilitySummary) {
                    primarySummary = item.vulnerabilitySummary;
                  } else if (item.strainSummary) {
                    primarySummary = item.strainSummary;
                  } else if (item.regulatoryAssessment) {
                    primarySummary = item.regulatoryAssessment;
                  }
                  
                  // Add the primary summary as a brief signal context
                  if (primarySummary) {
                    return (
                      <>
                        <br />
                        <span className="italic">{primarySummary}</span>
                      </>
                    );
                  }
                  return null;
                })()}
              </p>
              <Button
                size="sm"
                className="mt-[5px] h-[24px] text-[9px] font-semibold"
                onClick={(e) => e.stopPropagation()}
              >
                {item.actionLabel}
              </Button>
            </div>
          ))}
        </div>
        </div>
      </CardContent>
    </Card>
  );
};